export const Z_INDEX = {
  SCROLL_TO_TOP: Number.MAX_SAFE_INTEGER,
};
